// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__20eE4","productName":"Table_productName__hjWD-"};